export default __webpack_public_path__ + "static/Blog-8c87f8c1ee29a51435c8e52138c6fd02.jpg";